// Copyright (c) 2016 Deere & Company

import CreateClaimModal, {getDefaultState} from '../../../shared/state/create-claim-modal';
import actions from '../../action-list';

const resetModalState = state => {

    const createClaimModalState = getDefaultState();

    return CreateClaimModal.update(createClaimModalState, {
        claimTypes: {
            $set: state.claimTypes
        }
    });

};

const updateClaimModalMode = (state, action) =>
    CreateClaimModal.update(state, {
        mode: {
            $set: action.mode
        }
    });

const updateClaimTypes = (state, action) =>
    CreateClaimModal.update(state, {
        claimTypes: {
            $set: action.claimTypes
        }
    });

const updateCreateClaimModalVisibility = (state, action) =>
    CreateClaimModal.update(state, {
        isModalOpen: {
            $set: action.isVisible
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_SPA]: resetModalState,
        [actions.UPDATE_CLAIM_SPA_MODAL_MODE]: updateClaimModalMode,
        [actions.UPDATE_CLAIM_SPA_CLAIM_TYPES]: updateClaimTypes,
        [actions.UPDATE_CLAIM_SPA_CREATE_CLAIM_MODAL_VISIBILITY]: updateCreateClaimModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/spa/reducers/create-claim-modal.js